import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [comingSoon, setComingSoonState] = useState(true);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => setComingSoonState(!!data.coming_soon))
      .finally(() => setReady(true));
  }, []);

  const setComingSoon = async (value) => {
    const { data } = await api.put("/settings", { coming_soon: value });
    setComingSoonState(!!data.coming_soon);
    return data.coming_soon;
  };

  return (
    <SettingsContext.Provider value={{ comingSoon, ready, setComingSoon }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
